import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SEOHead from '@/components/SEOHead';
import FilloutHeroSection from '@/components/fillout/FilloutHeroSection';
import FilloutExpertiseSection from '@/components/fillout/FilloutExpertiseSection';
import FilloutServicesSection from '@/components/fillout/FilloutServicesSection';
import FilloutPortfolioSection from '@/components/fillout/FilloutPortfolioSection';
import FilloutTestimonialsSection from '@/components/fillout/FilloutTestimonialsSection';
import FilloutPricingCalculator from '@/components/fillout/FilloutPricingCalculator';
import FilloutWhyChooseSection from '@/components/fillout/FilloutWhyChooseSection';
import FilloutFAQSection from '@/components/fillout/FilloutFAQSection';
import FilloutCTASection from '@/components/fillout/FilloutCTASection';
import FilloutStructuredData from '@/components/fillout/FilloutStructuredData';

const FilloutExpert = () => {
  if (import.meta.env.DEV) {
    console.log('FilloutExpert page rendering');
  }
  const { t } = useTranslation('fillout');

  return (
    <div className="min-h-screen">
      <SEOHead page="fillout-expert" />
      <FilloutStructuredData />
      <Header />
      <main>
        <FilloutHeroSection />
        <FilloutExpertiseSection />
        <FilloutServicesSection />
        <FilloutPortfolioSection />
        <FilloutTestimonialsSection />
        <FilloutPricingCalculator />
        <FilloutWhyChooseSection />
        <FilloutFAQSection />
        <FilloutCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default FilloutExpert;